import { render, staticRenderFns } from "./DeviceTV.vue?vue&type=template&id=0d8296d9&"
import script from "./DeviceTV.vue?vue&type=script&lang=js&"
export * from "./DeviceTV.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports